import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { StoreExt } from '@utils/reactExt'

import { coupons } from '@services/api'

export class couponsStore extends StoreExt {
    @observable loading = false
    @observable list = []
    @observable selected = []
    @observable filters: any = {}
    @observable pagination: any = {}
    @observable editValues = {}
    @observable errors = {}

    @action
    addCoupons = async () => {
        this.loading = true
        const { coupon_type_id } = this.filters
        coupons
            .addCoupons({ ...this.editValues, coupon_type_id })
            .then(res => {
                this.getList()
            })
            .catch(e => {
                console.log({ ...e })
                runInAction(() => {
                    this.list = []
                    this.errors = { serverError: 'קיימת שגיאה בשרת' }
                })
            })
        this.loading = false
    }

    @action
    updateCoupons = async () => {
        this.loading = true
        const { coupon_type_id } = this.filters
        coupons
            .updateCoupons({ ...this.editValues, coupon_type_id, selected: this.selected.join(',') })
            .then(res => {
                this.getList()
            })
            .catch(e => {
                console.log({ ...e })
                runInAction(() => {
                    this.errors = { serverError: 'קיימת שגיאה בשרת' }
                })
            })
        this.loading = false
    }

    @action
    selectAll = () => {
        const newSelected = []
        if (this.selected.length < this.list.length) {
            this.list.forEach(item => newSelected.push(item.id))
        }
        runInAction(() => {
            this.selected = [...newSelected]
        })
    }

    @action
    editSelected = id => {
        const newSelected = [...this.selected]
        const selectedIndex = newSelected.indexOf(id)
        if (selectedIndex > -1) {
            newSelected.splice(selectedIndex, 1)
        } else {
            newSelected.push(id)
        }
        runInAction(() => {
            this.selected = [...newSelected]
        })
    }

    @action
    getList = async () => {
        this.loading = true
        coupons
            .getCoupons({ ...this.filters })
            .then(res => {
                const { perPage, page, total } = res.data
                runInAction(() => {
                    this.list = res.data.data
                    this.editValues = {}
                    this.pagination = { perPage, page, total }
                    this.errors = {}
                    this.selected = []
                })
            })
            .catch(e => {
                runInAction(() => {
                    this.list = []
                    this.errors = { serverError: 'קיימת שגיאה בשרת' }
                })
            })
        this.loading = false
    }

    @action
    addFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (name in newFilters && !value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = newFilters
        })
    }

    @action
    resetFilters = (filters = []) => {
        if (filters.length > 0) {
            const newFilters = { ...this.filters }
            filters.forEach(filter => filter in newFilters && delete newFilters[filter])
            runInAction(() => {
                this.filters = newFilters
            })
        } else {
            this.filters = {}
        }
    }

    @action
    setEditValue = (name, value) => {
        const newValues = { ...this.editValues }
        if (name in newValues && !value) {
            delete newValues[name]
        } else {
            newValues[name] = value
        }
        runInAction(() => {
            this.editValues = newValues
        })
    }

    @action
    resetEditValues = () => {
        this.editValues = {}
    }

    @action
    resetList = () => {
        this.list = []
    }
}

export default remotedev(new couponsStore())
